unable to read source [project]/packages/core/src/devtools/utils.ts